import { render } from "./section-two.vue?vue&type=template&id=0726aabf&scoped=true"
import script from "./section-two.vue?vue&type=script&lang=js"
export * from "./section-two.vue?vue&type=script&lang=js"

import "./section-two.vue?vue&type=style&index=0&id=0726aabf&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0726aabf"]])

export default __exports__